export const SAVE_MULTI = {};
export const STOP_CHECK_ELEMENT = 'stop-check-element';
export const STOP_CHECK_OPERATION_ELEMENT = 'stop-check-operation-element';
